<div class="overflow-hidden pos-relative z-2"
     [sizeClass]="'X: wrap'"
     [style]="client.isX ? 'padding-left: 9px !important;' : ''">
    <div class="_wrapper _hidden flex"
         style="width: min-content;"
         [toggleClass]="'!_hidden'"
         [toggleClassBy]="toggleGroupId"
         [elementHeight]="'shop-submenu'"
         (mouseenter)="onMouseIn(0)"
         (mouseleave)="onMouseOut(0)">

        <!-- First level -->
        <div style="width: 350px;"
             class="bg-col-w p-t inline-block b-t b-col-5 _level flex-column">
            <div class="flex-grow overflow-y-auto overflow-x-hidden p-r-10 p-l-10">
                <ng-container *ngFor="let item of items">
                    <href (mouseenter)="changeSecondLevelItem(item)"
                          [link]="item?.link">
                        <div class="p-t-4 p-b-4 b-b b-col-5 flex flex-justify-between">
                            <p class="p2"
                               [ngClass]="item === secondLevelItem ? 'col-1' : 'col-12'"
                               *iCms="'title' of item; content 'html'"></p>
                            <i class="icon-chevron-right"
                               [ngClass]="item === secondLevelItem ? 'col-1' : 'col-12'"
                               *ngIf="item.submenus?.length > 0"
                               [lineHeightBy]="'p2'"
                               aria-hidden="true"></i>
                        </div>
                    </href>
                </ng-container>
                <ng-content></ng-content>
            </div>
            <div class="m-t p-a-2 p-l-10 p-r-10 center"
                 [ngClass]="promobannerBackround + ' ' + promobannerColor">
                <span class="m-r-2"
                      [lineHeightBy]="'p2'">
                    <i [style.font-size.px]="16"
                       [ngClass]="promobannerBlocks[0]?.icon"
                       aria-hidden="true"></i>
                </span>
                <span class="p2"
                      *iCms="'copy' of promobannerBlocks[0]; content 'html'"></span>
            </div>
        </div>
        <!-- Second level -->
        @if(secondLevelOpened) {
        <div style="width: 350px; min-height: 100%;"
             class="bg-col-w p-t inline-block pos-relative b-l b-t b-col-5 _level flex-column">
            <div class="flex-grow overflow-auto">
                <ng-container *ngFor="let item of secondLevelItem?.submenus">
                    <href (mouseenter)="changeThirdLevelItem(item)"
                          [link]="item?.link">
                        <div class="p-t-4 p-b-4 m-l-5 m-r-5 b-b b-col-5 flex flex-justify-between">
                            <p class="p2"
                               [ngClass]="item === thirdLevelItem ? 'col-1' : 'col-12'"
                               *iCms="'title' of item; content 'html'"></p>
                            <i class="icon-chevron-right"
                               [ngClass]="item === thirdLevelItem ? 'col-1' : 'col-12'"
                               *ngIf="item.submenus?.length > 0"
                               [lineHeightBy]="'p2'"
                               aria-hidden="true"></i>
                        </div>
                    </href>
                </ng-container>
                <div class="m-t m-l-5 m-r-5 p-b-1">
                    <href [link]="secondLevelItem?.submenuLink">
                        <p class="s1 _submenu-link"
                           *iCms="'submenuLinkCopy' of secondLevelItem; content 'html'"></p>
                    </href>
                </div>
            </div>
            <div class="m-t p-a-2 p-l-10 p-r-10 center"
                 [ngClass]="promobannerBackround + ' ' + promobannerColor">
                <span class="m-r-2"
                      [lineHeightBy]="'p2'">
                    <i [style.font-size.px]="16"
                       [ngClass]="promobannerBlocks[1]?.icon"
                       aria-hidden="true"></i>
                </span>
                <span class="p2"
                      *iCms="'copy' of promobannerBlocks[1]; content 'html'"></span>
            </div>
        </div>
        }
        <!-- Third level -->
        @if(thirdLevelOpened) {
        <div style="width: 350px; min-height: 100%;"
             class="bg-col-w p-t inline-block pos-relative b-l b-t b-col-5 _level flex-column">
            <div class="flex-grow overflow-auto">
                <ng-container *ngFor="let item of thirdLevelItem?.submenus">
                    <href [link]="item?.link">
                        <div class="p-t-4 p-b-4 m-l-5 m-r-5 b-b b-col-5 flex flex-justify-between _item">
                            <p class="p2"
                               *iCms="'title' of item; content 'html'"></p>
                        </div>
                    </href>
                </ng-container>
                <div class="m-t m-l-5 m-r-5 p-b-1">
                    <href [link]="thirdLevelItem?.submenuLink">
                        <p class="s1 _submenu-link"
                           *iCms="'submenuLinkCopy' of thirdLevelItem; content 'html'"></p>
                    </href>
                </div>
            </div>
            <div class="m-t p-a-2 p-l-10 p-r-10 center"
                 [ngClass]="promobannerBackround + ' ' + promobannerColor">
                <span class="m-r-2"
                      [lineHeightBy]="'p2'">
                    <i [style.font-size.px]="16"
                       [ngClass]="promobannerBlocks[2]?.icon"
                       aria-hidden="true"></i>
                </span>
                <span class="p2"
                      *iCms="'copy' of promobannerBlocks[2]; content 'html'"></span>
            </div>
        </div>
        }
    </div>
</div>

<!-- overlay -->
<overlay [visible]="toggleService.getState(toggleGroupId)"
         class="z-1"></overlay>